import {
    getDisplayValue
} from '../format-display-value';

import {
    timestampMerger
} from './timestamp-merger';

/**
 * Station data should consist of the following format
 * {
 *  HistoricForecast: [
 *      {
 *          DewPoint: null
 *          Gust: null
 *          Humidity: number
 *          IsForecast: boolean
 *          IsWindCalculated: boolean
 *          Rainfall10AM: null
 *          Rainfall9AM: null
 *          StationDateTicks: number
 *          StationDateTime: string
 *          StationId: number
 *          StationName: string
 *          Temperature: number
 *          WeatherObservationId: number
 *          WindDirDeg: number
 *          WindDirection: string
 *          WindSpeed: number
 *          wind_src: null
 *      }
 *  ],
 *  Observations: [
 *      {
 *          DewPoint: number,
 *          Gust: null,
 *          Humidity: number,
 *          IsForecast: boolean,
 *          IsWindCalculated: boolean,
 *          Rainfall10AM: number
 *          Rainfall9AM: number,
 *          StationDateTicks: number,
 *          StationDateTime: string,
 *          StationId: number,
 *          StationName: string,
 *          Temperature: number,
 *          WeatherObservationId: number,
 *          WindDirDeg: null,
 *          WindDirection: null,
 *          WindSpeed: null,
 *          wind_src
 *      }
 *  ],
 *  StationInfo: {
 *      CsDashboardId: null,
 *      DeploymentStatus: null,
 *      Description: string,
 *      Elevation: number,
 *      FTSID: null,
 *      ForecastDistrictId: string,
 *      FunctionalStatus: null,
 *      InList: null,
 *      JurisdictionId: number,
 *      JurisdictionName: string,
 *      Latitiude: string,
 *      LinkUrl: string,
 *      Longitude: number,
 *      StationAnemometerHeight: null,
 *      StationName: string,
 *      StationNumber: string,
 *      StreetAddress: null,
 *      Tz: string,
 *      UnitType: string,
 *      WMOID: number,
 *      WarningValid: null,
 *      WeatherStationId: number
 *  }
 * }
 * @param {*} detailsContainer 
 * @param {*} stationData 
 */
export function drawWHistoryWindDirChart(detailsContainer, stationData, chartHeight) {
    // Create the temperature 
    const temp = [[
        'Datetime', 
        'Wind Direction', 
        'Observed Wind Direction', 
        {role: 'annotation', type: 'string'}
    ]];

    // Get the historical forecast temperature
    const histTemp = stationData['HistoricForecast'];
    const obsvTemp = stationData['Observations'];

    const comboTimeline = timestampMerger(histTemp, obsvTemp);

    // Reuse the historical forecast and observation counters
    let histWDirCounter = 0;
    let obsvWDirCounter = 0; 

    for(let i = 0; i < comboTimeline.length; i++) {
        const writeList = [comboTimeline[i], null, null, null];
        
        if(histWDirCounter < histTemp.length) {
            const fHistHumid = getDisplayValue(histTemp[histWDirCounter]['WindDirDeg'], '2dp');
            const histDate = new Date(histTemp[histWDirCounter]['StationDatetime']);
            if(comboTimeline[i].getTime() === histDate.getTime()) {
                writeList[1] = fHistHumid;
                histWDirCounter += 1;
            }
        }

        if(obsvWDirCounter < obsvTemp.length) {
            const fObsvHumid = getDisplayValue(obsvTemp[obsvWDirCounter]['WindDirDeg'], '2dp');
            const obsvDate = new Date(obsvTemp[obsvWDirCounter]['StationDatetime']);
            if(comboTimeline[i].getTime() === obsvDate.getTime()) {
                writeList[2] = fObsvHumid;
                obsvWDirCounter += 1;
            }
        }

        if(obsvWDirCounter === obsvTemp.length - 1) {
            writeList[3] = 'Current';
        }

        temp.push(writeList);   
    }

    const data = google.visualization.arrayToDataTable(temp);

    const options = {
        title: 'Wind Direction (Deg)',
        legend: 'none',
        chartArea: {width: '85%'},
        height: +chartHeight.slice(0, -2),
        seriesType: 'line',
        interpolateNulls: true, // Ensure the line chart's points are connected
        vAxis: {
            ticks: [0, 90, 180, 270, 360]
        },
        series: {
            1: {
                type: 'scatter',
                pointSize: 1
            }
        },
        annotations: {
            stem: {
              color: '#097138'
            },
            style: 'line',
        },
    };

    const chartContainer = $(`<div class="no-data ` + 
            `line-chart-container ` + 
            `chart-container-style" ` + 
            `id="w-dir-w-history-line-chart-id"` + 
            `style="height:${chartHeight};"></div>`);
    detailsContainer.append(chartContainer);

    const chart = new google.visualization.ComboChart(document.getElementById("w-dir-w-history-line-chart-id"));
    chart.draw(data, options);
}